import { Injectable } from '@angular/core';
import dexFreight from '@microservices';
import { CacheListener } from 'src/app/@utils/cache-listener';
import { IpcService } from '../ipc.service';
import { IPCChannel } from 'src/app/@enums/IPCChannel.enum';
import { DataRegistryService } from 'src/app/data-registry.service';
import { onInvalidSession } from 'src/app/@utils/invalid-session';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    public token: CacheListener<string> = new CacheListener("token", this.validatedToken(localStorage.getItem('token')), this.syncToken.bind(this));

    private sessionExpired = false;

    constructor(
        private ipc: IpcService,
        private ds: DataRegistryService
    ) {
        this.ds.registerCacheListeners(this.token);
        onInvalidSession(() => this.expireSession());
    }

    getToken () {
        return localStorage.getItem('token');
    }

    async login(email: string, password: string) {
        return await dexFreight.Auth.login(email, password);
    }

    async resetPasswordToken(email: string) {
        return await dexFreight.Auth.resetPasswordToken(email);
    }

    setLocalItem(key: string, value: string) {
        localStorage.setItem(key, value);
    }

    setLocalJson(key: string, value: unknown) {
        this.setLocalItem(key, JSON.stringify(value));
    }

    getLocalItem(key: string) {
        return localStorage.getItem(key);
    }

    removeLocalItem(key: string) {
        localStorage.removeItem(key);
    }

    validatedToken (token?: string) {
        if (!token) return null;
        let content;
        try {
            content = JSON.parse(atob(token.split('.')[1]));
        } catch {
            return null;
        }
        if (content.type !== 'access') return null;
        if (content.exp && content.exp * 1000 <= Date.now()) return null;

        return token;
    }

    syncToken (token?: string) {
        if (token) localStorage.setItem('token', token);
        token = localStorage.getItem('token');

        if (!token) return null;

        return this.validatedToken(token);
    }

    clear () {
        localStorage.removeItem('token');
        this.token.clear();
    }

    async logout () {
        await this.broadcastLogout();
        await this.clearSession();
    }

    async clearSession () {
        this.token.clear();
        window.location.href = '/'
    }

    // El backend rechazó el token (firma inválida, caducado): sin esto la pantalla
    // de arranque se queda esperando datos que nunca llegan.
    expireSession () {
        if (this.sessionExpired) return;
        this.sessionExpired = true;
        this.clear();
        window.location.href = '/';
    }

    async broadcastLogout () {
        this.ipc.send(IPCChannel.Logout, {});
    }

}
